import React, { useState, useEffect } from 'react';
import * as Yup from 'yup';
import { Formik, Form, Field } from 'formik';
import Select, { components } from 'react-select';
import MaskedInput from 'react-text-mask';
import { getInvalidFieldClass } from '../../../helpers/validation';
import schemas from '../../../helpers/validation/schemas/PartnerFields';
import FormType from './PropTypes/PVPartnerContentForm';
import { createHTMLText } from '../../../helpers/textFunctions';
import { WebServiceHosts, AuthHeader } from '../../../helpers/siteConfigConstants';
import { getPostBody, getAPIEndPoint } from '../../../helpers/template1/form';
//import { getAPIEndPoint } from '../../../helpers/template1/apiURL';

const PVTemplate1Form = (props) => {
    const { formData } = props;

    const [showPIOther, setShowPIOther] = useState(false);
    const [showHDYHOther, setShowHDYHOther] = useState(false);
    const [formSubmitted, setFormSubmitted] = useState(false);
    const [formSubmitting, setFormSubmitting] = useState(false);
    const [formSuccess, setFormSuccess] = useState(false);
    const [formError, setFormError] = useState(false);

    const handleLoaded = _ => {
        window.grecaptcha.ready(_ => {
            window.grecaptcha
                .execute("6LejeSsUAAAAAOg2gsl92Lop9Y1kXDW7qZ7QzM34", { action: "homepage" })
                .then(token => {
                    // ...
                })
        })
    }

    useEffect(() => {
        // Add reCaptcha
        const script = document.createElement("script")
        script.src = "https://www.google.com/recaptcha/api.js?render=6LejeSsUAAAAAOg2gsl92Lop9Y1kXDW7qZ7QzM34"
        script.addEventListener("load", handleLoaded)
        document.body.appendChild(script)
    }, [])
     
    const initialValues = {
        FullName: '',
        FirstName: '',
        LastName: '',
        Company: '',
        Phone: '',
        Email: '',
        ZipCode: '',
        PrimaryIndustry: '',
        PrimaryIndustryOther: '',
        HowDidYouHear: '',
        HowDidYouHearOther: '',
    };

    const validationSchema = Yup.object().shape({
        FullName: formData.useFirstAndLastName ? Yup.string() : schemas.fullNameRequired,
        FirstName: formData.useFirstAndLastName ? schemas.firstNameRequired : Yup.string(),
        LastName: formData.useFirstAndLastName ? schemas.lastNameRequired : Yup.string(),
        Company: schemas.companyRequired,
        Phone: schemas.phoneRequired,
        Email: schemas.emailRequired,
        ZipCode: schemas.usZip5Optional4Required,
        PrimaryIndustry: formData.getPrimaryIndustry ? schemas.primaryIndustry : Yup.string(),
        PrimaryIndustryOther: formData.getPrimaryIndustry
            ? Yup.string()
                  .min(2, 'Other must be at least 2 characters long.')
                  .max(30, 'Other must be no longer than 30 characters')
                  .when('PrimaryIndustry', {
                      is: (val) => val === 'Other',
                      then: Yup.string().required('This is a required field.'),
                  })
            : Yup.string(),
        HowDidYouHear: formData.hideHowDidYouHear ? Yup.string() : schemas.howDidYouHear,
        HowDidYouHearOther: Yup.string()
            .min(2, 'Other must be at least 2 characters long.')
            .max(30, 'Other must be no longer than 30 characters')
            .when('HowDidYouHear', {
                is: (val) => val === 'Other',
                then: Yup.string().required('This is a required field.'),
            }),
    });

    const getButtonStyle = () =>
         formData.class.toLowerCase() === 'pv-template1-form-perfectvision'
            ? 'btn-default'
            : 'btn-primary';

    const pvSelectStyles = {
        container: (provided, state) => ({
            ...provided,
            backgroundColor: 'hsl(0,0%,100%)',
            border: state.isFocused ? '1px solid #0033A0' : '1px solid #bdbdbd',
        }),
        option: (provided, state) => ({
            ...provided,
            color: state.isFocused ? '#FFFFFF' : '#333333',
            backgroundColor: state.isFocused ? '#0033A0' : '#FFFFFF',
            padding: 5,
        }),
        control: () => ({
            alignItems: 'center',
            borderRadius: 0,
            cursor: 'default',
            display: 'flex',
            flexWrap: 'wrap',
            justifyContent: 'space-between',
            minHeight: '30px',
            outline: '0 !important',
            position: 'relative',
            transition: 'all 100ms',
            boxSizing: 'border-box',
        }),
        indicatorSeparator: (provided) => ({
            ...provided,
            visibility: 'hidden',
        }),
        input: (provided) => ({
            ...provided,
            margin: '0',
            padding: '0',
        }),
        menu: (provided) => ({
            ...provided,
            borderRadius: '0',
            margin: '0',
        }),
    };

    const DropdownIndicator = (innerProps) => {
        return (
            components.DropdownIndicator && (
                <components.DropdownIndicator {...innerProps}>
                    <i className="fa fa-sort" />
                </components.DropdownIndicator>
            )
        );
    };

    const howDidYouHearValues = [
        {
            value: 'Web Search',
            text: 'Web Search',
        },
        {
            value: 'LinkedIn',
            text: 'LinkedIn',
        },
        {
            value: 'Facebook',
            text: 'Facebook',
        },
        {
            value: 'Instagram',
            text: 'Instagram',
        },
        {
            value: 'CE Pro',
            text: 'CE Pro',
        },
        {
            value: 'Craigslist',
            text: 'Craigslist',
        },
        {
            value: 'Other',
            text: 'Other',
        },
        {
            value: 'DIRECTV PIP Express Referral',
            text: 'DIRECTV PIP Express Referral',
        },
    ];

    const handleSubmit = (values, actions) => {
        actions.validateForm();
        var response = grecaptcha.getResponse();
        if (response.length == 0) {
            //reCaptcha not verified
            alert("Please verify you are not a Robot!");
            evt.preventDefault();
            return false;
        }
        setFormSubmitting(true);
        const requestUri = `${WebServiceHosts.WebStore}${getAPIEndPoint(formData.formType)}`;
  
        const fetchBody = getPostBody(values, formData);
        fetch(requestUri, {
            method: 'POST',
            mode: 'cors',
            cache: 'no-cache',

            headers: {
                Authorization: AuthHeader,
                'Content-Type': 'application/json',
            },
            body: fetchBody,
        })
            .then((res) => res.json())
            .then((response) => {
                setFormSubmitted(true);
                 //console.log('Response:', JSON.stringify(response));
                if (response.response) {
                    setFormSuccess(true);
                } else {
                    setFormError(true);
                }


             
            })
            .catch((_error) => {
                setFormSubmitted(true);
                setFormError(true);
            });
        /* eslint-enable no-console */
    };

    const zipMask = (rawValue) => {
        if (rawValue.length < 6) {
            return [/\d/, /\d/, /\d/, /\d/, /\d/];
        }
        return [/\d/, /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/];
    };

    const PVFormikTextBox = (tbProps) => {
        const { id, type, label, mask, maskGuide, formObj, fieldObj } = tbProps;
        const thisMask = !mask ? false : mask;
        const thisMaskGuide = !maskGuide ? false : maskGuide;
        return (
            <div className="pv form-group">
                <label htmlFor={id} className="control-label">
                    {label}
                </label>
                <MaskedInput
                    {...fieldObj}
                    type={type}
                    className={`pv form-control ${getInvalidFieldClass(fieldObj.name, formObj)}`}
                    id={id}
                    mask={thisMask}
                    guide={thisMaskGuide}
                />
                <div
                    className={`pv-text-tiny ${
                        getInvalidFieldClass(fieldObj.name, formObj) === '' ? 'hidden' : ''
                    }`}
                >
                    {formObj.errors[fieldObj.name]}
                </div>
            </div>
        );
    };

    /* eslint-disable react/no-danger */
    return (
        <React.Fragment>
            <div className="pv-template1-header-form-wrapper">
                <div className={`pv-template1-header-form-box ${formData.class}`}>
                    <div className={formSubmitted ? 'hidden' : ''}>
                        <div
                            className="pv-template1-header-form-header"
                            dangerouslySetInnerHTML={createHTMLText(formData.title)}
                        />
                        <Formik
                            initialValues={initialValues}
                            validationSchema={validationSchema}
                            onSubmit={(values, actions) => handleSubmit(values, actions)}
                        >
                            <Form>
                                <div className={`pv form-group ${
                                    formData.useFirstAndLastName ? 'hidden' : ''
                                    }`}
                                >
                                    <Field name="FullName">
                                        {({ field, form }) => {
                                            return (
                                                <PVFormikTextBox
                                                    id="txtFullName"
                                                    type="text"
                                                    label="Full Name *"
                                                    formObj={form}
                                                    fieldObj={field}
                                                />
                                            );
                                        }}
                                    </Field>
                                </div>

                                <div className={`pv form-group ${
                                    formData.useFirstAndLastName ? '' : 'hidden'
                                    }`}
                                >
                                    <Field name="FirstName">
                                        {({ field, form }) => {
                                            return (
                                                <PVFormikTextBox
                                                    id="txtFirstName"
                                                    type="text"
                                                    label="First Name *"
                                                    formObj={form}
                                                    fieldObj={field}
                                                />
                                            );
                                        }}
                                    </Field>
                                </div>

                                <div className={`pv form-group ${
                                    formData.useFirstAndLastName ? '' : 'hidden'
                                    }`}
                                >
                                    <Field name="LastName">
                                        {({ field, form }) => {
                                            return (
                                                <PVFormikTextBox
                                                    id="txtLastName"
                                                    type="text"
                                                    label="Last Name *"
                                                    formObj={form}
                                                    fieldObj={field}
                                                />
                                            );
                                        }}
                                    </Field>
                                </div>

                                <div className="pv form-group">
                                    <Field name="Company">
                                        {({ field, form }) => {
                                            return (
                                                <PVFormikTextBox
                                                    id="txtCompany"
                                                    type="text"
                                                    label="Company *"
                                                    formObj={form}
                                                    fieldObj={field}
                                                />
                                            );
                                        }}
                                    </Field>
                                </div>

                                <div className="pv form-group">
                                    <Field name="Phone">
                                        {({ field, form }) => {
                                            return (
                                                <PVFormikTextBox
                                                    id="txtPhone"
                                                    label="Phone *"
                                                    type="tel"
                                                    formObj={form}
                                                    fieldObj={field}
                                                />
                                            );
                                        }}
                                    </Field>
                                </div>
                                <div className="pv form-group">
                                    <Field name="Email">
                                        {({ field, form }) => {
                                            return (
                                                <PVFormikTextBox
                                                    id="txtEmail"
                                                    type="text"
                                                    label="Email *"
                                                    formObj={form}
                                                    fieldObj={field}
                                                />
                                            );
                                        }}
                                    </Field>
                                </div>
                                <div className="pv form-group">
                                    <Field name="ZipCode">
                                        {({ field, form }) => {
                                            return (
                                                <PVFormikTextBox
                                                    id="txtZipCode"
                                                    type="text"
                                                    label="Zip Code *"
                                                    mask={zipMask}
                                                    formObj={form}
                                                    fieldObj={field}
                                                />
                                            );
                                        }}
                                    </Field>
                                </div>
                                <div
                                    className={`pv form-group ${
                                        formData.getPrimaryIndustry ? '' : 'hidden'
                                    }`}
                                >
                                    <Field name="PrimaryIndustry">
                                        {({ field, form }) => {
                                            const { name } = field;
                                            const { setFieldValue } = form;
                                            return (
                                                <div className="pv form-group">
                                                    <label
                                                        htmlFor="txtPrimaryIndustry"
                                                        className="control-label"
                                                    >
                                                        Primary Industry *
                                                    </label>
                                                    <Select
                                                        id="txtPrimaryIndustry"
                                                        placeholder="Choose a Primary Industry"
                                                        name={name}
                                                        styles={pvSelectStyles}
                                                        components={{ DropdownIndicator }}
                                                        className={getInvalidFieldClass(
                                                            field.name,
                                                            form
                                                        )}
                                                        options={formData.primaryIndustry}
                                                        getOptionLabel={(option) => option.text}
                                                        getOptionValue={(option) => option.value}
                                                        filterOptions={{
                                                            ignoreCase: true,
                                                            ignoreAccents: true,
                                                            trim: true,
                                                        }}
                                                        defaultValue={form.values[name]}
                                                        onChange={(inputValue, { action }) => {
                                                            const newVal = inputValue.value;
                                                            if (action === 'select-option') {
                                                                setFieldValue(name, newVal);
                                                            }
                                                            setShowPIOther(newVal === 'Other');
                                                        }}
                                                    />
                                                    <div
                                                        className={`pv-text-tiny ${
                                                            getInvalidFieldClass(
                                                                field.name,
                                                                form
                                                            ) === ''
                                                                ? 'hidden'
                                                                : ''
                                                        }`}
                                                    >
                                                        {form.errors[name]}
                                                    </div>
                                                </div>
                                            );
                                        }}
                                    </Field>
                                </div>
                                <div className={`pv form-group ${showPIOther ? '' : 'hidden'}`}>
                                    <Field name="PrimaryIndustryOther">
                                        {({ field, form }) => {
                                            return (
                                                <PVFormikTextBox
                                                    id="txtPrimaryIndustryOther"
                                                    type="text"
                                                    label="Other Primary Industry *"
                                                    formObj={form}
                                                    fieldObj={field}
                                                />
                                            );
                                        }}
                                    </Field>
                                </div>
                                <div className={`pv form-group ${
                                    formData.hideHowDidYouHear ? 'hidden' : ''
                                    }`}
                                >

                                    <Field name="HowDidYouHear">
                                        {({ field, form }) => {
                                            const { name } = field;
                                            const { setFieldValue } = form;
                                            return (
                                                <div className="pv form-group">
                                                    <label
                                                        htmlFor="txtHowDidYouHear"
                                                        className="control-label"
                                                    >
                                                        How did you hear about us? *
                                                    </label>
                                                    <Select
                                                        id="txtHowDidYouHear"
                                                        placeholder="Choose How You Heard About Us"
                                                        name={name}
                                                        className={getInvalidFieldClass(
                                                            field.name,
                                                            form
                                                        )}
                                                        styles={pvSelectStyles}
                                                        components={{ DropdownIndicator }}
                                                        options={howDidYouHearValues}
                                                        getOptionLabel={(option) => option.text}
                                                        getOptionValue={(option) => option.value}
                                                        filterOptions={{
                                                            ignoreCase: true,
                                                            ignoreAccents: true,
                                                            trim: true,
                                                        }}
                                                        defaultValue={form.values[name]}
                                                        onChange={(inputValue, { action }) => {
                                                            const newVal = inputValue.value;
                                                            if (action === 'select-option') {
                                                                setFieldValue(name, newVal);
                                                            }
                                                            setShowHDYHOther(newVal === 'Other');
                                                        }}
                                                    />
                                                    <div
                                                        className={`pv-text-tiny ${
                                                            getInvalidFieldClass(
                                                                field.name,
                                                                form
                                                            ) === ''
                                                                ? 'hidden'
                                                                : ''
                                                        }`}
                                                    >
                                                        {form.errors[name]}
                                                    </div>
                                                </div>
                                            );
                                        }}
                                    </Field>
                                </div>
                                <div className={`pv form-group ${showHDYHOther ? '' : 'hidden'}`}>
                                    <Field name="HowDidYouHearOther">
                                        {({ field, form }) => {
                                            return (
                                                <PVFormikTextBox
                                                    id="txtHowDidYouHearOther"
                                                    type="text"
                                                    label="Other *"
                                                    formObj={form}
                                                    fieldObj={field}
                                                />
                                            );
                                        }}
                                    </Field>
                                </div>
                                <div className={`pv form-group`}>
                                    <div
                                        className="g-recaptcha"
                                        data-sitekey="6LejeSsUAAAAAH-O3pIY8F-YeOotJZ4Gk9ir5Fq3"
                                        data-size="compact"
                                        data-theme="light"
                                    ></div>
                                </div>
                                <span className="pv-text-small">* indicates required field</span>
                                <button
                                    style={{ cursor: 'pointer' }}
                                    type="submit"
                                    className={`pv btn ${getButtonStyle()} pull-right ${
                                        formSubmitting ? 'disabled' : ''
                                    }`}
                                >
                                    Submit
                                </button>
                                <div
                                    className={`pv form-group ${
                                        formData.showHaveAccount ? '' : 'hidden'
                                    }`}
                                >
                                    <br />
                                    <br />
                                    <span className="pv-text-large">
                                        Already have an account?
                                        <a href={formData.haveAccountLink}>Sign in </a>
                                    </span>
                                </div>
                            </Form>
                        </Formik>
                        <br className="clearfix" />
                        &nbsp;
                    </div>
                    <div className={formSuccess ? '' : 'hidden'}>
                        <div
                            className="pv-template1-header-form-header"
                            dangerouslySetInnerHTML={createHTMLText(formData.success)}
                        />
                    </div>
                    <div className={formError ? '' : 'hidden'}>
                        <div className="pv-template1-header-form-error">
                            <p>There was an error submitting your form.</p>
                            <p>Please reload the page and try again.</p>
                            <p>
                                If the problem persists, please contact PerfectVision at
                                800-205-8620.
                            </p>
                        </div>
                    </div>
                </div>
                <div
                    className="pv-template1-header-form-footer pv-text-small"
                    dangerouslySetInnerHTML={createHTMLText(formData.footer)}
                />
            </div>
        </React.Fragment>
    );
    /* eslint-enable react/no-danger */
};

PVTemplate1Form.propTypes = {
    formData: FormType,
};

PVTemplate1Form.defaultProps = {
    formData: {},
};

export default PVTemplate1Form;
